var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-page-not-found',{staticClass:"va-page-not-found-large-text"},[_c('div',{staticClass:"va-page-not-found-large-text__number",attrs:{"slot":"image"},slot:"image"},[_vm._v("404")])])
}
var staticRenderFns = []

export { render, staticRenderFns }